// this is an autogenerated file from DesignSystem/TimegridOverrideTemplate/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_TimegridOverrideTemplate(
  $chair_id: uuid!
  $slot_time: timestamp!
  $appointment_type_id: uuid!
) {
  calendar_override_chair_template(
    args: {
      _chair_id: $chair_id
      _slot_time: $slot_time
      _appointment_type_id: $appointment_type_id
    }
  ) {
    _id
  }
}

`